import asArray from 'utils/arrays/asArray.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

const rankFragmentsWithMatchesCount = (options) => {
  const strings = asArray(options?.strings).map(fromAnyToString);
  const needle = options?.needle;

  return strings.filter((fragment) => fragment.indexOf(needle) !== -1).length;
};

export default rankFragmentsWithMatchesCount;
